import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput";
import FloatInput from "components/Input/FloatInput";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { plan2dItemText } from "variables/MBM/geb";
import {
  item2dlayerData, planitemiconData, item2dpointaggData, item2dvaluetypeData,
  item2diconsizeData, item2dtextsizeData, item2dstepcolorData
} from "variables/MBM/lists/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEB2dPlanItem, putGEB2dPlanItem } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";
import CustomSelectWithIcon from "components/Input/CustomSelectWithIcon";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const EquipmentPointDiv = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
display:flex;
margin-left: 10px;
`;
const EquipmentPointName = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 11px;
`;
const EquipmentPointTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 11px;
  margin-left: 10px;
`;

function Plan2dItemDialog(props) {

  const { closeModal, refetch, currentItem, fullpoints, points, iots, equipments, avobboxs, lorawanboxs, plan, eventx, eventy, plans } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const { chartIdGroup } = advancedSearchContext;

  const [selected, setSelected] = useState("");

  const [relativex, setRelativex] = useState(currentItem?.parameters.relativex || eventx);
  const [relativey, setRelativey] = useState(currentItem?.parameters.relativey || eventy);

  const [name, setName] = useState(currentItem?.parameters.name || "");
  const [displayname, setDisplayname] = useState(currentItem?.parameters.displayname || false);
  const [layer, setLayer] = useState(currentItem?.parameters.layer || "");

  const [valuetype, setValuetype] = useState(currentItem?.parameters.valuetype || "");
  const [value, setValue] = useState(currentItem?.parameters.value || "");
  const [valueagg, setValueagg] = useState(currentItem?.parameters.valueagg || "");
  const [controltype, setControltype] = useState(currentItem?.parameters.controltype || "");
  const [controlvalue, setControlvalue] = useState(currentItem?.parameters.controlvalue || "");
  const [unit, setUnit] = useState(currentItem?.parameters.unit || "");
  const [coef, setCoef] = useState(currentItem?.parameters.coef || "");
  const [textsize, setTextsize] = useState(currentItem?.parameters.textsize || "");
  const [defaultvalcolor, setDefaultvalcolor] = useState(currentItem?.parameters.defaultvalcolor || "");
  const [lowvalcolor, setLowvalcolor] = useState(currentItem?.parameters.lowvalcolor || "");
  const [highvalcolor, setHighvalcolor] = useState(currentItem?.parameters.highvalcolor || "");
  const [lowvalstep, setLowvalstep] = useState(currentItem?.parameters.lowvalstep || "");
  const [highvalstep, setHighvalstep] = useState(currentItem?.parameters.highvalstep || "");
  const [displayedpoints, setDisplayedpoints] = useState(currentItem?.parameters.displayedpoints || []);

  const [iot, setIot] = useState(currentItem?.parameters.iot || "");

  const [equipment, setEquipment] = useState(currentItem?.parameters.equipment || "");

  const [avobbox, setAvobbox] = useState(currentItem?.parameters.avobbox || "");
  const [lorawanbox, setLorawanbox] = useState(currentItem?.parameters.lorawanbox || "");
  const [linkedplan, setLinkedplan] = useState(currentItem?.parameters.linkedplan || "");

  const [icon, setIcon] = useState(currentItem?.parameters.icon || "");
  const [iconsize, setIconsize] = useState(currentItem?.parameters.iconsize || "");

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [pointswithequipmentname, setPointswithequipmentname] = useState([]);
  useEffect(() => {
    let pointswithequipmentnametmp = points.map((pt) => {
      return { ...pt, name: pt.equipmentname ? pt.equipmentname + ' - ' + pt.name : pt.name }
    });
    setPointswithequipmentname(pointswithequipmentnametmp);
  }, [points]);

  const classes = useStyles();

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDisplaynameChange = (event) => { setDisplayname(!displayname); };
  const handleTextsizeChange = (event) => { setTextsize(event.target.value); };
  const handleIconChange = (event) => { setIcon(event.target.value); };
  const handleIconsizeChange = (event) => { setIconsize(event.target.value); };

  const handleDefaultvalcolorChange = (event) => { setDefaultvalcolor(event.target.value); };
  const handleLowvalcolorChange = (event) => { setLowvalcolor(event.target.value); };
  const handleHighvalcolorChange = (event) => { setHighvalcolor(event.target.value); };
  const handleLowvalstepChange = (event) => { setLowvalstep(event.target.value); };
  const handleHighvalstepChange = (event) => { setHighvalstep(event.target.value); };
  const handleValuetypeChange = (event) => { setValuetype(event.target.value); };
  const handleValueaggChange = (event) => { setValueagg(event.target.value); };

  const handleUnitChange = (event) => { setUnit(event.target.value); };
  const handleCoefChange = (event) => { setCoef(event.target.value); };

  const handleDisplayequipmentpointsChange = (event, id) => {
    let tmpdisplayedpoints = [...displayedpoints];
    if (tmpdisplayedpoints.find((point) => point.id == id)) {
      if (tmpdisplayedpoints.find((point) => point.id == id).display === 'false')
        tmpdisplayedpoints.find((point) => point.id == id).display = 'true';
      else
        tmpdisplayedpoints.find((point) => point.id == id).display = 'false';
    }
    else
      tmpdisplayedpoints.push({ id: id, display: 'false' });
    setDisplayedpoints(tmpdisplayedpoints);
  }

  //Point selection management
  const [selectedPoint, setSelectedPoint] = useState(currentItem?.parameters?.value ? points.find((b) => b.id == currentItem.parameters.value) : "");
  const handlePointChange = (newValue) => {
    setValue(newValue?.id || ""); //use of id and not pointid to avoid sync issues, will be take into account at chart generation
    setSelectedPoint(newValue);
  };
  const selectedPointFunc = () => {
    let selected = {};
    if (selectedPoint !== undefined) {
      selected = selectedPoint;
    }
    return selected;
  };

  //Iot selection management
  const [selectedIot, setSelectedIot] = useState(currentItem?.parameters?.iot ? iots.find((b) => b.id == currentItem.parameters.iot) : "");
  const handleIotChange = (newValue) => {
    setIot(newValue?.id || "");
    setSelectedIot(newValue);
  };
  const selectedIotFunc = () => {
    let selected = {};
    if (selectedIot !== undefined) {
      selected = selectedIot;
    }
    return selected;
  };

  //Equipment selection management
  const [selectedEquipment, setSelectedEquipment] = useState(currentItem?.parameters?.equipment ? equipments.find((b) => b.id == currentItem.parameters.equipment) : "");
  const handleEquipmentChange = (newValue) => {
    if (equipment !== newValue?.id) {
      setValue("");
      setSelectedPoint("");
    }
    setEquipment(newValue?.id || "");
    setSelectedEquipment(newValue);
  };
  const selectedEquipmentFunc = () => {
    let selected = {};
    if (selectedEquipment !== undefined) {
      selected = selectedEquipment;
    }
    return selected;
  };



  //AVOB Box selection management
  const [selectedAvobbox, setSelectedAvobbox] = useState(currentItem?.parameters?.avobbox ? avobboxs.find((b) => b.id == currentItem.parameters.avobbox) : "");
  const handleAvobboxChange = (newValue) => {
    setAvobbox(newValue?.id || "");
    setSelectedAvobbox(newValue);
  };
  const selectedAvobboxFunc = () => {
    let selected = {};
    if (selectedAvobbox !== undefined) {
      selected = selectedAvobbox;
    }
    return selected;
  };

  //LoRawan Box selection management
  const [selectedLorawanbox, setSelectedLorawanbox] = useState(currentItem?.parameters?.lorawanbox ? lorawanboxs.find((b) => b.id == currentItem.parameters.lorawanbox) : "");
  const handleLorawanboxChange = (newValue) => {
    setLorawanbox(newValue?.id || "");
    setSelectedLorawanbox(newValue);
  };
  const selectedLorawanboxFunc = () => {
    let selected = {};
    if (selectedLorawanbox !== undefined) {
      selected = selectedLorawanbox;
    }
    return selected;
  };

  //Linkedplan selection management
  const [selectedPlan, setSelectedPlan] = useState(currentItem?.parameters?.linkedplan ? plans.find((b) => b.id == currentItem.parameters.linkedplan) : "");
  const handleLinkedplanChange = (newValue) => {
    setLinkedplan(newValue?.id || "");
    setSelectedPlan(newValue);
  };
  const selectedPlanFunc = () => {
    let selected = {};
    if (selectedPlan !== undefined) {
      selected = selectedPlan;
    }
    return selected;
  };

  const handleLayerChange = (event) => {
    setLayer(event.target.value);
    setDisplayname(false);
    setIcon("");
    setIconsize("");
    setTextsize("");
    setValue("");
    setSelectedPoint("");
    setIot("");
    setSelectedIot("");
    setEquipment("");
    setSelectedEquipment("");
    setAvobbox("");
    setLorawanbox("");
    setSelectedAvobbox("");
    setSelectedLorawanbox("");
  };

  const handleSubmit = (event) => {
    if (currentItem)
      updateItem(event);
    else
      createItem(event);
  };

  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [name]);

  const createItem = async (event) => {
    let newitem = {
      parameters: {
        name,
        displayname,
        layer,
        textsize,
        valuetype,
        value,
        valueagg,
        defaultvalcolor,
        lowvalcolor,
        highvalcolor,
        lowvalstep,
        highvalstep,
        controltype,
        controlvalue,
        unit,
        coef,
        icon,
        iconsize,
        relativex,
        relativey,
        avobbox,
        lorawanbox,
        equipment,
        iot,
        linkedplan,
        displayedpoints,
      }
    }
    axios
      .post(
        postGEB2dPlanItem(plan.id),
        newitem
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Item créé");
          refetch(plan.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const updateItem = async (event) => {
    let newitemparameters = {
      ...currentItem.parameters,
      name,
      displayname,
      layer,
      textsize,
      valuetype,
      value,
      valueagg,
      defaultvalcolor,
      lowvalcolor,
      highvalcolor,
      lowvalstep,
      highvalstep,
      controltype,
      controlvalue,
      unit,
      coef,
      icon,
      iconsize,
      relativex,
      relativey,
      avobbox,
      lorawanbox,
      equipment,
      iot,
      linkedplan,
      displayedpoints,
    }
    axios
      .put(
        putGEB2dPlanItem(currentItem.id),
        newitemparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Item modifié");
          refetch(plan.id);
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={plan2dItemText.name}
                textInput={name}
                multiline
                rows={3}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={plan2dItemText.displayname}
                checkedState={displayname}
                handleSwitchChange={handleDisplaynameChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={plan2dItemText.type}
                selectValue={layer}
                handleSelectValueChange={handleLayerChange}
                data={item2dlayerData}
                disabled={currentItem}
              />
            </div>
            {
              layer ?
                layer === 'link' ?
                  <>
                    <div>
                      <AutocompleteInputMeters
                        specialWidth={"97%"}
                        inputMargin={"1rem 0rem 0rem"}
                        inputTitle={plan2dItemText.linkedplan}
                        selected={selectedPlanFunc()}
                        list={plans.filter((p) => p.id !== plan.id)}
                        handleChange={(_, newValue) =>
                          handleLinkedplanChange(newValue)
                        }
                      />
                    </div>
                    {/* {
                      currentItem ?
                        <div>
                          <TextInput
                            inputTitle={plan2dItemText.linkedplan}
                            textInput={linkedplan ? plans.find((b) => b.id == linkedplan)?.name || "" : ""}
                            disabled
                          />
                        </div> :
                        <div>
                          <AutocompleteInputMeters
                            specialWidth={"97%"}
                            inputMargin={"1rem 0rem 0rem"}
                            inputTitle={plan2dItemText.linkedplan}
                            selected={selectedPlanFunc()}
                            list={plans.filter((p) => p.id !== plan.id)}
                            handleChange={(_, newValue) =>
                              handleLinkedplanChange(newValue)
                            }
                          />
                        </div>
                    } */}

                  </>
                  :
                  layer === 'data' ?
                    <>
                      <div>
                        <CustomSelect
                          inputTitle={plan2dItemText.textsize}
                          selectValue={textsize}
                          handleSelectValueChange={handleTextsizeChange}
                          data={item2dtextsizeData}
                        />
                      </div>
                      <div>
                        <CustomSelect
                          inputTitle={plan2dItemText.valuetype}
                          selectValue={valuetype}
                          handleSelectValueChange={handleValuetypeChange}
                          data={item2dvaluetypeData}
                          disabled={currentItem}
                        />
                      </div>
                      {
                        valuetype === 'point' ?
                          <>
                            {/* {
                              currentItem ?
                                <div>
                                  <TextInput
                                    inputTitle={plan2dItemText.name}
                                    textInput={value ? pointswithequipmentname.find((b) => b.id == value)?.name || "" : ""}
                                    disabled
                                  />
                                </div> :
                                <div>
                                  <AutocompleteInputMeters
                                    specialWidth={"97%"}
                                    inputMargin={"1rem 0rem 0rem"}
                                    inputTitle={plan2dItemText.value}
                                    selected={selectedPointFunc()}
                                    list={pointswithequipmentname}
                                    handleChange={(_, newValue) =>
                                      handlePointChange(newValue)
                                    }
                                  />
                                </div>
                            } */}
                            <div>
                              <AutocompleteInputMeters
                                specialWidth={"97%"}
                                inputMargin={"1rem 0rem 0rem"}
                                inputTitle={plan2dItemText.value}
                                selected={selectedPointFunc()}
                                list={pointswithequipmentname}
                                handleChange={(_, newValue) =>
                                  handlePointChange(newValue)
                                }
                              />
                            </div>
                            <div>
                              <TextInput
                                inputTitle={plan2dItemText.unit}
                                textInput={unit}
                                handleTextInputChange={handleUnitChange}
                              />
                            </div>
                            <div>
                              <FloatInput
                                inputTitle={plan2dItemText.coef}
                                floatInput={coef}
                                handleFloatInputChange={handleCoefChange}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={plan2dItemText.valueagg}
                                selectValue={valueagg}
                                handleSelectValueChange={handleValueaggChange}
                                data={item2dpointaggData}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={plan2dItemText.defaultvalcolor}
                                selectValue={defaultvalcolor}
                                handleSelectValueChange={handleDefaultvalcolorChange}
                                data={item2dstepcolorData}
                              />
                            </div>
                            <div>
                              <FloatInput
                                inputTitle={plan2dItemText.lowvalstep}
                                floatInput={lowvalstep}
                                handleFloatInputChange={handleLowvalstepChange}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={plan2dItemText.lowvalcolor}
                                selectValue={lowvalcolor}
                                handleSelectValueChange={handleLowvalcolorChange}
                                data={item2dstepcolorData}
                                disabled={lowvalstep === undefined || lowvalstep === ""}
                              />
                            </div>
                            <div>
                              <FloatInput
                                inputTitle={plan2dItemText.highvalstep}
                                floatInput={highvalstep}
                                handleFloatInputChange={handleHighvalstepChange}
                              />
                            </div>
                            <div>
                              <CustomSelect
                                inputTitle={plan2dItemText.highvalcolor}
                                selectValue={highvalcolor}
                                handleSelectValueChange={handleHighvalcolorChange}
                                data={item2dstepcolorData}
                                disabled={highvalstep === undefined || highvalstep === ""}
                              />
                            </div>
                          </>
                          : <></>
                      }
                    </> :
                    <>
                      <div>
                        <CustomSelectWithIcon
                          inputTitle={plan2dItemText.icon}
                          selectValue={icon}
                          handleSelectValueChange={handleIconChange}
                          data={planitemiconData}
                        />
                      </div>
                      <div>
                        <CustomSelect
                          inputTitle={plan2dItemText.iconsize}
                          selectValue={iconsize}
                          handleSelectValueChange={handleIconsizeChange}
                          data={item2diconsizeData}
                        />
                      </div>
                      {layer === 'iot' ?
                        <>
                          <div>
                            <AutocompleteInputMeters
                              specialWidth={"97%"}
                              inputMargin={"1rem 0rem 0rem"}
                              inputTitle={plan2dItemText.iot}
                              selected={selectedIotFunc()}
                              list={iots}
                              handleChange={(_, newValue) =>
                                handleIotChange(newValue)
                              }
                            />
                          </div>
                          {/* {
                          currentItem ?
                            <div>
                              <TextInput
                                inputTitle={plan2dItemText.name}
                                textInput={iot ? iots.find((b) => b.id == iot)?.name || "" : ""}
                                disabled
                              />
                            </div> :
                            <div>
                              <AutocompleteInputMeters
                                specialWidth={"97%"}
                                inputMargin={"1rem 0rem 0rem"}
                                inputTitle={plan2dItemText.iot}
                                selected={selectedIotFunc()}
                                list={iots}
                                handleChange={(_, newValue) =>
                                  handleIotChange(newValue)
                                }
                              />
                            </div>
                        } */}
                        </> :
                        layer === 'equipments' ?
                          <>
                            <div>
                              <AutocompleteInputMeters
                                specialWidth={"97%"}
                                inputMargin={"1rem 0rem 0rem"}
                                inputTitle={plan2dItemText.equipment}
                                selected={selectedEquipmentFunc()}
                                list={equipments}
                                handleChange={(_, newValue) =>
                                  handleEquipmentChange(newValue)
                                }
                              />
                            </div>
                            {/* {
                              currentItem ?
                                <div>
                                  <TextInput
                                    inputTitle={plan2dItemText.name}
                                    textInput={equipment ? equipments.find((b) => b.id == equipment)?.name || "" : ""}
                                    disabled
                                  />
                                </div> :
                                <div>
                                  <AutocompleteInputMeters
                                    specialWidth={"97%"}
                                    inputMargin={"1rem 0rem 0rem"}
                                    inputTitle={plan2dItemText.equipment}
                                    selected={selectedEquipmentFunc()}
                                    list={equipments}
                                    handleChange={(_, newValue) =>
                                      handleEquipmentChange(newValue)
                                    }
                                  />
                                </div>
                            } */}
                            <div>
                              <AutocompleteInputMeters
                                specialWidth={"97%"}
                                inputMargin={"1rem 0rem 0rem"}
                                inputTitle={plan2dItemText.primaryvalue}
                                selected={selectedPointFunc()}
                                list={fullpoints.filter((p) => p.equipment == equipment)}
                                handleChange={(_, newValue) =>
                                  handlePointChange(newValue)
                                }
                              />
                            </div>
                            {/* {
                              (currentItem && value) ?
                                <div>
                                  <TextInput
                                    inputTitle={plan2dItemText.primaryvalue}
                                    textInput={value ? points.find((b) => b.id == value)?.name || "" : ""}
                                    disabled
                                  />
                                </div>
                                :
                                <div>
                                  <AutocompleteInputMeters
                                    specialWidth={"97%"}
                                    inputMargin={"1rem 0rem 0rem"}
                                    inputTitle={plan2dItemText.primaryvalue}
                                    selected={selectedPointFunc()}
                                    list={fullpoints.filter((p) => p.equipment == equipment)}
                                    handleChange={(_, newValue) =>
                                      handlePointChange(newValue)
                                    }
                                  />
                                </div>
                            } */}
                            {
                              value ?
                                <>

                                  <div>
                                    <TextInput
                                      inputTitle={plan2dItemText.unit}
                                      textInput={unit}
                                      handleTextInputChange={handleUnitChange}
                                    />
                                  </div>
                                  <div>
                                    <FloatInput
                                      inputTitle={plan2dItemText.coef}
                                      floatInput={coef}
                                      handleFloatInputChange={handleCoefChange}
                                    />
                                  </div>
                                  <div>
                                    <CustomSelect
                                      inputTitle={plan2dItemText.valueagg}
                                      selectValue={valueagg}
                                      handleSelectValueChange={handleValueaggChange}
                                      data={item2dpointaggData}
                                    />
                                  </div></>
                                : <></>
                            }
                            {
                              equipment ?
                                <>
                                  <EquipmentPointTitle>{plan2dItemText.equipmentpoints}</EquipmentPointTitle>
                                  {fullpoints.map((p) => {
                                    if (p.equipment == equipment) {
                                      return <EquipmentPointDiv>
                                        <div>
                                          <CustomSwitch
                                            style={{ margin: "0rem 0rem 0rem 1rem" }}
                                            inputTitle={""}
                                            checkedState={(!displayedpoints.find((point) => point.id == p.id) ||
                                              (displayedpoints.find((point) => point.id == p.id).display === 'true'))}
                                            handleSwitchChange={(event) => handleDisplayequipmentpointsChange(event, p.id)}
                                          />
                                        </div>
                                        <EquipmentPointName>{p.name}</EquipmentPointName>
                                      </EquipmentPointDiv>
                                    }
                                    else
                                      return <></>

                                  })

                                  }

                                </>
                                : <></>
                            }
                          </> :

                          layer === 'avobbox' ?
                            <>
                              <div>
                                <AutocompleteInputMeters
                                  specialWidth={"97%"}
                                  inputMargin={"1rem 0rem 0rem"}
                                  inputTitle={plan2dItemText.box}
                                  selected={selectedAvobboxFunc()}
                                  list={avobboxs}
                                  handleChange={(_, newValue) =>
                                    handleAvobboxChange(newValue)
                                  }
                                />
                              </div>
                              {/* {
                                currentItem ?
                                  <div>
                                    <TextInput
                                      inputTitle={plan2dItemText.name}
                                      textInput={avobbox ? avobboxs.find((b) => b.id == avobbox)?.name || "" : ""}
                                      disabled
                                    />
                                  </div> :
                                  <div>
                                    <AutocompleteInputMeters
                                      specialWidth={"97%"}
                                      inputMargin={"1rem 0rem 0rem"}
                                      inputTitle={plan2dItemText.box}
                                      selected={selectedAvobboxFunc()}
                                      list={avobboxs}
                                      handleChange={(_, newValue) =>
                                        handleAvobboxChange(newValue)
                                      }
                                    />
                                  </div>
                              } */}

                            </>
                            :
                            layer === 'lorawanbox' ?
                              <>
                                <div>
                                  <AutocompleteInputMeters
                                    specialWidth={"97%"}
                                    inputMargin={"1rem 0rem 0rem"}
                                    inputTitle={plan2dItemText.box}
                                    selected={selectedLorawanboxFunc()}
                                    list={lorawanboxs}
                                    handleChange={(_, newValue) =>
                                      handleLorawanboxChange(newValue)
                                    }
                                  />
                                </div>
                                {/* {
                                  currentItem ?
                                    <div>
                                      <TextInput
                                        inputTitle={plan2dItemText.name}
                                        textInput={lorawanbox ? lorawanboxs.find((b) => b.id == lorawanbox)?.name || "" : ""}
                                        disabled
                                      />
                                    </div> :
                                    <div>
                                      <AutocompleteInputMeters
                                        specialWidth={"97%"}
                                        inputMargin={"1rem 0rem 0rem"}
                                        inputTitle={plan2dItemText.box}
                                        selected={selectedLorawanboxFunc()}
                                        list={lorawanboxs}
                                        handleChange={(_, newValue) =>
                                          handleLorawanboxChange(newValue)
                                        }
                                      />
                                    </div>
                                } */}

                              </>

                              :
                              <></>
                      }
                    </>
                : <></>}
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default Plan2dItemDialog;
